import {numUtil} from '@/helper/num';

export function convertPrice(isMarket, priceEp, pricePrecision, quoteQtyScale) {
  return isMarket ? 'Market' : numUtil.delimit(numUtil.floor(priceEp, pricePrecision, quoteQtyScale));
}
